import React from "react";
import Button from "../../Framework/Components/Buttons/Button";
import {ColourMod, FlexAlign, FlexGap} from "../../Framework/Data/Enums/LayoutEnums";
import StackHorizontal from "../../Framework/Components/Wrappers/StackHorizontal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCrown, faEnvelope, faKey, faTrash, faUser, faUserCrown, faWavePulse} from "@fortawesome/pro-solid-svg-icons";
import {useLayout} from "../../Framework/Providers/LayoutProvider";
import {ButtonSize, ToggleType} from "../../Framework/Data/Enums/Generic";
import ToggleSwitch from "../../Framework/Components/Forms/Toggle/ToggleSwitch";
import {UserDataType, useUser} from "../../Api/UsersEndpoints";
import {faCogs} from "@fortawesome/pro-light-svg-icons";
import ItemMenuEntry from "../../Framework/Components/Navigation/ItemMenuEntry";
import DropdownMenu from "../../Framework/Components/DropdownMenus/DropdownMenu";
import Pill from "../../Framework/Components/Pills/Pill";
import {PillSize} from "../../Framework/Components/Pills/PillTypes";

interface UserEntryType extends UserDataType {
    passwordResetCallback: any;
    deleteCallback: any;
    disableCallback: any;
}

const SendsUserItem = (props: UserEntryType) => {
    const { isMedium, isXL } = useLayout();
    const { data } = useUser();

    const userRole = props.roles.includes('SENDS_PAGE_ADMIN') ? 'Admin' : props.roles.includes('MANAGER') ? 'Manager' : 'User';

    return (
        <div className={'item-row item-row-static pl-md pr-md'} style={{ gridTemplateColumns: isMedium ? 'repeat(3, 1fr) 5em' : '1fr 5em' }}>

            {isMedium ? (
                <>
                    <StackHorizontal gap={FlexGap.ExtraSmall} align={FlexAlign.Center}>
                        {userRole === 'User' ? (
                            <Pill title={userRole} size={PillSize.Large} content={<FontAwesomeIcon icon={faUser} fixedWidth={true} />} />
                        ) : (
                            <Pill title={userRole} size={PillSize.Large} colour={userRole === 'Admin' ? ColourMod.Success : ColourMod.Secondary} content={<FontAwesomeIcon icon={faCrown} fixedWidth={true} />} />
                        )}
                        {props.name}
                    </StackHorizontal>
                    <div>{props.userName}</div>
                    {data?.emailAddress !== props.userName && (
                        <>
                            <StackHorizontal gap={FlexGap.ExtraSmall}>
                                <Button onClick={() => props.deleteCallback()} title={'Delete'} squared={true} size={ButtonSize.Small} colour={ColourMod.Alert} iconOnly={!isXL} icon={<FontAwesomeIcon icon={faTrash} fixedWidth={true} /> }  />
                                <Button onClick={() => props.passwordResetCallback()} title={'Password Reset'} squared={true} size={ButtonSize.Small} colour={ColourMod.Primary} iconOnly={!isXL} icon={<FontAwesomeIcon icon={faEnvelope} fixedWidth={true} /> }  />
                            </StackHorizontal>
                            <div>
                                {/*<ToggleSwitch type={ToggleType.Switch} hideLabel={true} name={`user${props.userId}`} label={'Active'} checked={!props.isDisabled} onChange={(e: any) => props.disableCallback(!e.currentTarget.checked)} />
                            */}</div>
                        </>
                    )}
                </>
            ) : (
                <>
                    <div>
                        <h5 className={'m-0'}>{props.name}</h5>
                        {props.userName}
                    </div>
                    {data?.emailAddress !== props.userName && (
                        <div>
                            <Button title={'Actions'} squared={true} extraClass={`user-actions-${props.userId}`} icon={<FontAwesomeIcon icon={faCogs} fixedWidth={true} />} iconOnly={true} onClick={() => null}/>
                            <DropdownMenu target={[`user-actions-${props.userId}`]}>

                                <ItemMenuEntry
                                    title={'Password Reset'}
                                    callback={() => props.passwordResetCallback()}
                                    icon={<FontAwesomeIcon icon={faKey} fixedWidth={true} />}
                                />

{/*                                <ItemMenuEntry
                                    title={'Is Active?'}
                                    icon={<FontAwesomeIcon icon={faWavePulse} fixedWidth={true} />}
                                    callback={(e: any) => props.disableCallback(!e.currentTarget.checked)}
                                    addonContent={
                                        <ToggleSwitch type={ToggleType.Switch} hideLabel={true} label={'Active'} name={`user${props.userId}`}  checked={props.isDisabled} />
                                    }
                                />*/}

                                <ItemMenuEntry title={'Divider'} sectionDivider={true} />


                                <ItemMenuEntry
                                    title={'Delete'}
                                    callback={() => props.deleteCallback()}
                                    icon={<FontAwesomeIcon icon={faTrash} fixedWidth={true} />}
                                />
                            </DropdownMenu>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default SendsUserItem
